/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SortableList from '/client/src/components/sortableList/container';
import TicketLevelItem from './ticketLevelItem';
import arrayMove from 'array-move';
import { defaultLevelObj } from './defaultLevelObj';
import _ from 'lodash';

type PropsType = {
  tickets?: null | [],
  handleControlTicketLevels: (data: any) => void,
  setValidateDataLength?: (el: string, isRemove?: number) => void,
  isClone?: boolean,
  begin_time_utc: any,
  end_time_utc: any,
  current_inventory: any
};

class CreateEditEventLevels extends React.PureComponent<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      tickets: _.size(props.tickets) > 0
      ? props.tickets.sort((a, b): number => a.placement_index - b.placement_index)
      : [ defaultLevelObj(1, props.begin_time_utc, props.end_time_utc) ]
    };
  }

  // update tickets on event save
  componentDidUpdate(prevProps: any) {
    const prevIds = prevProps.tickets.map(el => el.id);
    const Ids = this.props.tickets.map(el => el.id);

    if (prevIds.includes(0) && !Ids.includes(0)) { // id === 0 means ticket was saved
      this.setState({
        tickets: _.size(this.props.tickets) > 0
        ? this.props.tickets.sort((a, b): number => a.placement_index - b.placement_index)
        : [ defaultLevelObj(1, this.props.begin_time_utc, this.props.end_time_utc) ]
      });
    }
  }

  handleChangeCheckbox = (e: SyntheticEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    const name = e.target.name;

    this.setState({
      [name]: value
    });
  };

  onSortEnd = ({ oldIndex, newIndex }: any) => {
    const { tickets } = this.state;
    const ticketsMoved = arrayMove(tickets, oldIndex, newIndex);
    const sortedTickets = _.map(ticketsMoved, (t: {}, i: number): {} => {
      return { ...t, placement_index: i + 1 };
    });

    this.setState({
      tickets: sortedTickets
    });
  };

  handleAddTicket = () => {
    const { tickets } = this.state;
    const _defaultLevelObj = defaultLevelObj(_.size(tickets) + 1, this.props.begin_time_utc, this.props.end_time_utc);
    const newItems = [
      ...tickets,
      {
        ..._defaultLevelObj,
        id: 0 - _.size(tickets),
        name: `New Ticket ${_.size(tickets) + 1}`,
        temp_id: -1001 - _.size(tickets) - 1
      }
    ];

    this.setState({
      tickets: newItems
    }, () => {
      this.props.handleControlTicketLevels(newItems);
    });
  };

  handleRemoveTicket = (tempId: string, id: string) => {
    const { tickets } = this.state;

    const newItems = _.map(tickets, (t: {}): {} => {
      if (t.tempId) {
        if (_.toString(t.tempId) !== _.toString(tempId)) {
          return t;
        }
      } else if (_.toString(t.id) !== _.toString(id)) {
          return t;
        }
    });

    this.setState({
      tickets: _.compact(newItems)
    }, () => {
      this.props.handleControlTicketLevels(_.compact(newItems), this.props.isClone);
    });
  };

  handleSetStatus =  (id: string, status: boolean) => {
    const { tickets } = this.state;

    const newItems = _.map(tickets, (t: {}): {} => {
      if (_.toString(t.id) === _.toString(id)) {
        t.is_active = status;
      }

      return t;
    });

    this.setState({
      tickets: _.compact(newItems)
    }, () => {
      this.props.handleControlTicketLevels(_.compact(newItems), this.props.isClone);
    });
  }

  render(): React.Fragment {
    const { tickets } = this.state;

    return (
      <div className="panel panel-default panel-page no-border">
        <div className="panel-heading panel-heading-blue">
          <div className="panel-title">
            Ticket Levels
          </div>
        </div>

        <div className="panel-body">
          <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <SortableList
                    panelClass={'panel-ticket'}
                    items={tickets}
                    isClone={this.props.isClone}
                    // eslint-disable-next-line
                    onSortEnd={this.onSortEnd}
                    useDragHandle
                    useWindowAsScrollContainer
                    disableAutoscroll
                    // eslint-disable-next-line
                    handleRemoveTicket={this.handleRemoveTicket}
                    // eslint-disable-next-line
                    handleSetStatus={this.handleSetStatus}
                    item={TicketLevelItem}
                    // eslint-disable-next-line
                    handleControlTicketData={this.props.handleControlTicketLevels}
                    setValidateDataLength={this.props.setValidateDataLength}
                    current_inventory={this.props.current_inventory}
                  />
                </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <button
                  className="btn btn-default btn-default-blue btn-lg btn-block btn-text-left"
                  type="button"
                  onClick={this.handleAddTicket}
                >
                  <i className="icon icon-plus-square" style={{ marginRight: '1rem' }} />
                  <span>Ticket Type</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateEditEventLevels;
